export const defaultColumns = [
  { label: "Status", value: "status" },
  { label: "Cod. Fatura", value: "number" },
  { label: "Agrupado por", value: "groupable_display_name" },
  { label: "Filial", value: "company_branch_info" },
  { label: "Limite/Empenho", value: "credit_info" },
  { label: "Vlr. Total", value: "total_amount", className: "text-green-400" },
  { label: "N. Transações", value: "events_count" },
  { label: 'Data de abertura', value: 'opened_at' },
  { label: 'Data de fechamento', value: 'closed_at' },
  { label: 'Período', value: 'period' },
  { label: "Ações", value: "actions", className: "w-9" },
];
